import {
  TagDefinitionFormDefaultValues,
  TagDefinitionFormProps,
  TagDefinitionFormRawValues,
  TagDefinitionFormType,
  TagDefinitionFormValues
} from "./TagDefinitionForm";
import {useTranslation} from "react-i18next";
import {createFormContext} from "@mantine/form";
import {TagDefinitionEntity,} from "@ots-frontend/ots-data";

export const toFormDefaultsFromTagDefinition = (def: TagDefinitionEntity | undefined): Partial<TagDefinitionFormValues> => {
  return {
    label: def?.label,
    description: def?.description,
    colorHex: def?.colorHex,
    doNotUse: def?.doNotUse,
  };
};

const getInitialValues = (defaultValues: TagDefinitionFormDefaultValues | undefined): TagDefinitionFormRawValues => {
  return {
    label: defaultValues?.label,
    description: defaultValues?.description,
    colorHex: defaultValues?.colorHex,
    doNotUse: defaultValues?.doNotUse,
  }
}

export const [TagDefinitionFormProvider, useTagDefinitionFormContext, useSharedTagDefinitionForm] = createFormContext<TagDefinitionFormRawValues>();

export type UseTagDefinitionFormProps = Pick<TagDefinitionFormProps, 'defaultValues'> & {}

export function useTagDefinitionForm(props: UseTagDefinitionFormProps): TagDefinitionFormType {
  const {
    defaultValues
  } = props

  const {t} = useTranslation(["common"])

  const form = useSharedTagDefinitionForm({
    initialValues: getInitialValues({
      ...defaultValues,
    }),
    validate: {
      label: (value) => value ? undefined : t("common.validation.required", "Required"),
    },
  })

  return form
}
